import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {BrowserQRCodeReader} from '@zxing/library';
import '../style/Scanner.css';
import {errorListPush} from "../state/action/alertActions";
import {AppError} from "../constant/appAlerts";

class Scanner extends Component {
    state = {
        //TODO: change to static variable. Not good practice to store non-serializable data in state.
        scanner: null
    };

    componentDidMount() {
        try {
            const codeReader = new BrowserQRCodeReader();
            codeReader.decodeFromInputVideoDevice(undefined, 'video')
                .then(this.onDetected)
                .catch((error) => {
                    console.log(error);
                    this.props.pushError(AppError.SCANNER_PERMISSION_ERROR);
                });
            this.setState({scanner: codeReader});
        } catch (e) {
            this.props.pushError(AppError.UNKNOWN_SCANNER_FAILURE);
        }
    }

    componentWillUnmount() {
        this.state.scanner.stop();
    }

    onDetected = result => {
        try {
            const parsedResult = this.parseScannerResult(result.text);
            if (this.props.validate(parsedResult)) {
                this.props.onDetected(parsedResult);
            } else {
                this.props.pushError(AppError.SCANNER_PARSE_ERROR);
                this.props.onValidateFail();
            }
        } catch (e) {
            this.props.onValidateFail();
            console.error('parse failed', {error: e, result: result});
            this.props.pushError(AppError.SCANNER_PARSE_ERROR);
        }
    };

    parseScannerResult(resultText) {
        const parsedResult = JSON.parse(resultText);
        const finalResult = {};

        //The factory may use upper and/or lower case for their Orbit data keys, so we need to account for that
        Object.keys(parsedResult).forEach(function (key) {
            var upperCaseKey = key.toUpperCase();
            if (upperCaseKey === 'MAC' || upperCaseKey === 'SN' || upperCaseKey === 'IN') {
                finalResult[key.toLowerCase()] = parsedResult[key];
            } else {
                finalResult[key] = parsedResult[key]
            }
        });

        return finalResult;
    }

    render() {
        return (
            <div className={'scanner-wrapper'}>
                <video id="video"/>
            </div>
        );
    }
}

Scanner.propType = {
    /**
     * Function called with data from QR after successful parse.
     */
    onDetected: PropTypes.func.isRequired,
    /**
     * Function called if parsing fails and scanner requires a reset.
     */
    onValidateFail: PropTypes.func.isRequired,
    /**
     * Function called to validate parsed result.
     */
    validate: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => {
    return {
        pushError: (error) => {
            dispatch(errorListPush(error));
        }
    };
};

export default connect(null, mapDispatchToProps)(Scanner);


// WEBPACK FOOTER //
// ./src/component/Scanner.jsx